import React, { useState } from 'react';
import {
  Modal,
  Text,
  Button,
  FormButton,
  Alert,
} from '@cochlear-design-system/foundation';
import patientService from '../../../services/patientService';
import { PatientRecordContext } from '../contexts/PatientRecordContext';

export const AuthorizationAssociateClinicModal = () => {
  const [isAssociating, setIsAssociating] = useState(false);
  const {
    showAuthorizationAssociateClinicModal,
    selectedClinic,
    setSelectedClinic,
    getFullName,
    setShowSelectSurgeryCentreModal,
    patientId,
    providerId,
    headingDetails,
    setHeadingDetails,
    startAssociationPolling,
    labels,
  } = React.useContext(PatientRecordContext);

  const addSelectedAssociatedClinic = async () => {
    const { clinicId, organisationType } = selectedClinic;
    // organisationType is mapped to role when associating clinic to a patient.
    setIsAssociating(true);
    const { success } = await patientService.associateWithClinic(
      patientId,
      providerId,
      organisationType,
      clinicId,
    );
    setIsAssociating(false);

    if (!success) {
      setHeadingDetails({
        ...headingDetails,
        alertConfig: {
          ...headingDetails.alertConfig,
          type: 'error',
          visible: true,
          title: `${labels['labels.patientRecord.views.associatedClinicsView.read.errorTitle']}`,
          message: `${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.error']}`,
          onClose: () => {},
        },
      });
      return;
    }

    setSelectedClinic(undefined);
    startAssociationPolling(clinicId);
  };

  return (
    <Modal
      show={showAuthorizationAssociateClinicModal}
      onHide={() => !isAssociating && setSelectedClinic(undefined)}
      size="xl"
    >
      <Modal.Header
        closeButton
        data-analytics="cancel_header_associate_clinic_modal"
      >
        <Modal.Title>
          {`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.title']}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!selectedClinic?.isClinicAssociated && (
          <>
            <Text
              content={`${
                labels[
                  'labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.patientName'
                ]
              }: ${getFullName()}`}
              type="body-text-bold"
            />
            <Text
              content={`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.additionalClinic']}: ${selectedClinic?.name}, ${selectedClinic?.address}`}
              type="body-text-bold"
            />
          </>
        )}

        <div
          style={{
            paddingTop: '2rem',
            paddingBottom: '1rem',
          }}
        >
          {!selectedClinic?.isClinicAssociated && (
            <Alert heading="" show>
              {`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.agreeToTitle']}`}
            </Alert>
          )}
          {selectedClinic?.isClinicAssociated && (
            <Alert heading="" show>
              {`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.clinicAssociatedTitle']}`}
            </Alert>
          )}
        </div>
        {!selectedClinic?.isClinicAssociated && (
          <>
            <Text
              content={`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.agreeToBody']}`}
              type="small-body-text"
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!selectedClinic?.isClinicAssociated && (
          <>
            <Button
              onClick={() => {
                setSelectedClinic(undefined);
                setShowSelectSurgeryCentreModal(true);
              }}
              text={`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.cancel']}`}
              variant="tertiary"
              disabled={isAssociating}
              data-analytics="cancel_associate_clinic_modal"
            />
            <FormButton
              onClick={async () => {
                await addSelectedAssociatedClinic();
              }}
              text={`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.agree']}`}
              type="save"
              progress={isAssociating ? 2 : undefined}
              data-analytics="agree_associate_clinic_modal"
            />
          </>
        )}
        {selectedClinic?.isClinicAssociated && (
          <Button
            onClick={async () => {
              setSelectedClinic(undefined);
            }}
            text={`${labels['labels.patientRecord.views.associatedClinicsView.associatingClinic.authorizationAssociateClinicModal.close']}`}
            data-analytics="close_associate_clinic_modal"
          />
        )}
      </Modal.Footer>
    </Modal>
  );
};
